import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import MrdContactsImpcColumns from '../../../contact-management/containers/MrdContactsImpcColumns';
import MrdAppTranslationsColumns from '../../containers/MrdAppTranslationsColumns';

export const getMrdImpcIsLoading = (state) => state.listing.MRD_IMPC_LIST_BY_COUNTRY.isLoading;
export const getMrdImpcData = TableDefinitions.MRD_IMPC_LIST_BY_COUNTRY.getDataFunction();
export const getMrdImpcColumns = createSelector(getMrdImpcData, MrdContactsImpcColumns);

export const getMrdAppTranslationsIsLoading = (state) => state.listing.MRD_APP_TRANSLATIONS.isLoading;
export const getMrdAppTranslationsData = TableDefinitions.MRD_APP_TRANSLATIONS.getDataFunction();
export const getMrdAppTranslationsColumns = createSelector(getMrdAppTranslationsData, MrdAppTranslationsColumns);

export const getPreservedImpc = (state) => state.translations.impcCode;
